<template>
  <v-container fluid name="nombreEnDessin">
        <table class="caisse">
          <tr 
          v-for="n in 5"
          :key="n">
            <td v-if="parsedNumber[0]>=5" > <img src=https://moncahier.com/maths/image/caisse.gif></td>
            <td v-if="6-n<=parsedNumber[0]%5" > <img src=https://moncahier.com/maths/image/caisse.gif></td>
            <td v-else >&nbsp;</td>
            <td v-if="parsedNumber[1]>=5"> <img  src=https://moncahier.com/maths/image/valise.gif></td>
            <td v-if="6-n<=parsedNumber[1]%5"> <img src=https://moncahier.com/maths/image/valise.gif></td>
            <td v-else >&nbsp;</td>
            <td v-if="n==5 && parsedNumber[2]>=5"> <img src=https://moncahier.com/maths/image/50.gif></td>
            <td v-if="n==5 && parsedNumber[2]%5>0"> <img :src="adresse10()"></td>
            <td v-else >&nbsp;</td>
            <td v-if="n==5 && parsedNumber[3]>=5"> <img src=https://moncahier.com/maths/image/5.gif></td>
            <td v-if="n==5 && parsedNumber[3]%5>0"> <img :src="adresse1()"></td>
          </tr>
        </table>
  </v-container>
</template>
<script>

  export default {
    name: "NombreEnDessin",
    components: {
    },
    computed: {
    },
    props: {
      parsedNumber:Array,
    },
    data () {
      return {
      }
    },
    methods: {
      adresse10:function(){
        return "https://moncahier.com/maths/image/"+this.parsedNumber[2]%5+"0.gif";
      },
      adresse1:function(){
        return "https://moncahier.com/maths/image/"+this.parsedNumber[3]%5+".gif";
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .ned{
    height: 30px;
  }
  .caisse{
    width:0px;
  }
</style>
